import { Stack, Typography } from '@mui/material';

import AlertIcon from '../../assets/icons/globalIcons/alert-icon';

interface IErrorComponentType {
  message?: string;
  state?: 'active' | 'error' | 'success' | 'disabled';
}

const ErrorComponent = ({ message, state = 'disabled' }: IErrorComponentType) => {
  return (
    <Stack direction="row" gap={0.5} alignItems="center" flexWrap="wrap">
      <AlertIcon />
      <Typography variant="caption" color={state} id="error">
        {message}
      </Typography>
    </Stack>
  );
};

export default ErrorComponent;
